
import React from 'react'
import { Input, Form, Button, message, Tooltip } from 'antd';
import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAES from '../../widget/WidgetAES';
import WidgetAjax from '../../widget/WidgetAjax';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
let path = Config.getBasePath();

class changePassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user_info: {},
      pwsTips: false,
      regular1: false, //密码校验规则
      regular2: false,
      regular3: false,
      sourcePath: Config.getSourcePath()
    }

  }

  componentDidMount() {
    this.getUserInfo();
    this.requirement();
  }

  requirement = () => {

    const onRequirement = (result, params) => {

      if (result.status === 0) {
        let password = result.password;

        let message = "密码中必须包含大小写字母、数字、特殊字符";

        let minLength = 10, maxLength = 20, complex = 2;

        if (password) {

          minLength = password.min_length;
          maxLength = password.max_length;

          complex = password.complex;


          switch (password.complex) {
            case 1:
            case "1":
              {
                message += "中的1项, "
                break;
              }
            case 2:
            case "2":
              {
                message += "中的2项, "
                break;
              }
            case 3:
            case "3":
              {
                message += "中的3项, "
                break;
              }
            case 4:
            case "4":
              {
                message += "中的4项, "
                break;
              }
            case 5:
            case "5":
              {
                message += "中的5项, "
                break;
              }
          }
          message += "长度至少" + minLength + "个字符，最多" + maxLength + "个字符!"
        }
        else {
          message = "密码中必须包含大小写字母、数字、特殊字符中的2项，长度至少8个字符，最多21个字符！"
        }
        this.setState({ requiredMessage: message, minLength: minLength, maxLength: maxLength, complex: complex });
      }
    }

    WidgetAjax.ajax({ url: Config.getBasePath() + '/requirement', params: undefined, callback: onRequirement });
  }

  verificatePassword = (value) => {

    const { complex, minLength, maxLength } = this.state;

    // 1. 长度校验 
    if (value.length < minLength) {

      this.setState({ requiredMessage: '密码长度不能少于' + minLength + '个字符!' });

      return false;
    }
    if (value.length > maxLength) {

      this.setState({ requiredMessage: '密码长度不能多于' + maxLength + '个字符!' });

      return false;
    }

    // 2. 复杂度校验 
    let size = 0;
    let regex;
    regex = new RegExp('[A-Z]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[a-z]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[0-9]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[.@$!%*#_~?&^]+');
    if (regex.test(value)) size++;
    if (size < complex) {

      this.setState({ requiredMessage: '密码中必须包含大写字母、小写字母、数字、特殊字符中' + complex + '项!' });

      return false;
    }
    return true;

  }

  onLogout = (result) => {
    if (result.status === 0) {
      sessionStorage.removeItem("_user_access_");
      sessionStorage.removeItem("_user_info_");
      sessionStorage.removeItem("_user_login_info_");
      if (this.props && this.props?.redrict !== undefined) {
        this.props.redrict("/login", undefined, true);
      } else {
        this.props.history.push({ pathname: '/login'});
      }
      window.location.reload()
    }
    else {
      sessionStorage.removeItem("_user_access_");
      sessionStorage.removeItem("_user_info_");
      sessionStorage.removeItem("_user_login_info_");

      message.error(result.message);

      if (this.props && this.props?.redrict !== undefined) {
        this.props.redrict("/login", undefined, true);
      } else {
        this.props.history.push({ pathname: '/login'});
      }

    }

    sessionStorage.removeItem("bindShow");
  }

  getUserInfo = () => {
    const onGetUser = (res) => {
      if (res.status == 0) {
        this.setState({ user_info: res.result });
        this.form.setFieldsValue(res.result)
      }
    }
    WidgetAjax.ajax({ url: path + "/info", callback: onGetUser })
  }

  logout() {
    WidgetAjax.ajax({ url: path + '/logout', params: undefined, callback: this.onLogout });
  }

  password = () => {
    let { new_password, old_password } = this.state;


    this.form.validateFields().then((value) => {

      this.setState({ isVisible: true });
      // old_password = this.$md5("ES_6ps" + old_password + "_N3tM").toUpperCase();
      // new_password = this.$md5("ES_6ps" + new_password + "_N3tM").toUpperCase();

      let nonce = Widget.randomString(6, true);

      let oldPasswordEncryption = this.$md5("ES_6ps" + old_password + "_N3tM").toUpperCase();
      let newPasswordEncryption = WidgetAES.encryptPassword(new_password, nonce);
      let params = {
        old_password: oldPasswordEncryption,
        new_password: newPasswordEncryption + nonce
      }

      const onPassword = (result) => {
        if (result.status === 0) {
          message.success("密码修改成功！");
          this.logout();
        } else {
          message.error("密码修改失败" + result.message);
        }
      }
      WidgetAjax.ajax({ url: Config.getBasePath() + '/update_password', params: params, callback: onPassword });

    })
  }



  validateCreditPassword = (rule, value, callback) => {

    const { username } = this.state;
    if (value) {
      let regular1 = false, regular2 = false, regular3 = false
      // const passwordRegex1 = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{6,20}$/; // 密码正则表达式，6到20个字符，包含字母、符号和数字
      const passwordRegex2 = /^[A-Za-z0-9\d!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/; // 密码正则表达式，只包含字母、数字以及除空格外的标点符号
      const passwordRegex3 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/; // 密码正则表达式，至少包含字母、数字和标点符号中的任意两种
      if (value.length > 6) //用户名 和 密码 不能一致
      {
        regular1 = true
      }
      if (passwordRegex2.test(value)) {
        regular2 = true
      }
      if (passwordRegex3.test(value)) {
        regular3 = true
      }
      if (regular1 && regular2 && regular3) {
        callback();
      }
      else {
        callback('密码格式不正确');
      }
      this.setState({ regular1, regular2, regular3 });

    } else {
      callback();
    }

  }


  render() {
    let that = this;
    const { user_info, old_password, new_password, pwsTips, regular1, regular2, regular3, sourcePath } = this.state;
    let layout = { labelCol: { span: 2 }, wrapperCol: { span: 6 } };
    return <div className='sf-box' style={{ minHeight: '926px' }}>
      <Form ref={ref => this.form = ref} {...layout} initialValues={user_info}>
        <Form.Item label="账号" name="username">
          <Input defaultValue={user_info?.username} disabled ></Input>
        </Form.Item>
        <Form.Item label="当前密码" name="old_password">
          <Input.Password placeholder="请输入当前的密码" defaultValue={old_password} onChange={(value) => { this.setState({ old_password: value.target.value }) }}></Input.Password>
        </Form.Item>
        <Form.Item label="新密码" name="new_password" tooltip={that.state.requiredMessage} rules={[
          { required: true, message: '请输入新密码!', },
          () => ({
            validator(_, value) {

              if (that.verificatePassword(value)) {
                return Promise.resolve();
              }
              else {
                return Promise.reject(new Error(that.state.requiredMessage));
              }

            },
          })
        ]} hasFeedback
        >
          <Input.Password placeholder="请输入新密码"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            onChange={(e) => this.setState({ newPassword: e.target.value })}
          />
        </Form.Item>
        <Form.Item label="确认新密码" name="confirm"
          dependencies={['new_password']} hasFeedback
          rules={[
            { required: true, message: '请输入确认密码!', },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('两次输入的密码不一致!'));
              },
            }),
          ]} >
          <Input.Password placeholder="确认新密码" autoComplete="new-password" defaultValue={new_password} onChange={(value) => { this.setState({ new_password: value.target.value }) }}></Input.Password>
        </Form.Item>
      </Form>
      <Button style={{ marginLeft: '12%', width: '200px' }} type="primary" onClick={() => { this.password(); }}>保存</Button>
    </div>
  }
}

export default changePassword;